'use strict';

module.exports = require('react').createClass;

